import axios from '@/libs/http'

/**
 * 获取店员技能申请信息列表
 */
export const getCategoryList = (pageNo, pageSize) => {
    return axios.request({
        url: '/s/c/categoryExamineCheck/list',
        params: {
            pageNo,
            pageSize
        },
        method: 'get'
    })
}
/**
 * 获取店员技能申请信息列表
 */
export const getCategoryExamineCheck = (id) => {
    return axios.request({
        url: '/s/c/categoryExamineCheck/detail',
        params: {
            id
        },
        method: 'get'
    })
}
